import { useQuery } from "@tanstack/react-query";
import { getHotelsForSelect } from "../../api/apiHotels";

const useGetHotelsForSelect = (filters = {}) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["hotels_for_select", filters],
    queryFn: () => getHotelsForSelect(filters),
    keepPreviousData: true,
    staleTime: 1000 * 60 * 10,
  });

  return {
    options: data?.data || [],
    isLoading,
    isError,
    error,
  };
};

export default useGetHotelsForSelect;
